export const environment = {
  production: false,
  API_URL: 'https://samapiuat.spcoindia.org/api/',
  RECAPTCHA_SITE_KEY: '6LfGtkYtAAAAAHncvacwJWv5g9qubp8NOBBCKV-2', // staging: API skips reCAPTCHA outside production, so '' is fine
};
